module.exports = __webpack_public_path__ + "media/images/page/page_catch-4d354f14cc12497dbd1cac197bc6c4bb.svg";